<div class="block--flex">
  <ez-checkbox-input
    #checkbox
    [name]="checkboxName()"
    [controlName]="controlName()"
    [isContentVisible]="false"
    [altText]="altText()"
    [required]="required()"
  >
    {{ label() }}
  </ez-checkbox-input>
  <ez-expandable [header]="label()" headerFontWeight="normal" [required]="required()">
    <ng-content select=".preview" class="preview"></ng-content>
    <ng-content></ng-content>
  </ez-expandable>
</div>
@if (checkbox.errorMessage(); as _message) {
  <p class="error-message" role="alert" [attr.aria-label]="label()">{{ _message }}</p>
}
